module.exports = __webpack_public_path__ + "img/1341858980.004c8b7b.jpg";